import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./validator";

import { FormField } from "../../../ui-kit/FormField/FormField";
import { IButton } from "../../../ui-kit/IButton/IButton";
import Api from "../../../api/Auth";
import DefectRegister from "../../../store/defectRegister";
import { useHistory, Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import styles from "./LoginForm.module.scss";
import defectRegister from "../../../store/defectRegister";
import { authStore } from "../../../store/authStore";
import ApiUrls from "../../../constants/ApiUrls";

export const ChooseOrganization: React.FC = observer(() => {
  const [orgs, setOrgs] = useState([]);
  const { esiaOrgs } = authStore;

  const history = useHistory();

  useEffect(() => {
    const searchString = new URLSearchParams(window.location.search);
    const oid = searchString.get("userId");
    authStore.setEsiaOid(oid);
    authStore.getOrgListEsia(oid);
  }, []);

  const loginByOrg = async (orgName) => {
    await authStore.loginByOrgEsia(orgName, history);
  };

  const cancel = async () => {
    // await authStore.logoutEsia(history);
    const res = await authStore.getLogoutUrl();
    location.assign(res.data);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Выберите организацию, под которой вы хотите зайти
        </h1>
      </div>
      {esiaOrgs && (
        <ul>
          {esiaOrgs.map((org, i) => (
            <div key={i}>
              <IButton
                className={styles.esiaOrgButton}
                type="button"
                onClick={() => {
                  loginByOrg(org.shortName);
                }}
                variant="outlined"
              >
                {org.shortName}
              </IButton>
            </div>
          ))}
        </ul>
      )}
      <IButton type="button" onClick={cancel} variant="outlined">
        Отмена
      </IButton>
    </div>
  );
});
